'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReduxForm = require('./createReduxForm');

var _createReduxForm2 = _interopRequireDefault(_createReduxForm);

var _plain = require('./structure/plain');

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createReduxForm2.default)(_plain2.default);


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/reduxForm.js
 ** module id = 838
 ** module chunks = 0
 **/